import "./GeneralInformation.css";
import React, { useEffect, useState } from "react";

export const GeneralInformation = ({
  systemType,
  calculatorDataResult,
  language,
}) => {
  const [formDataResult, setFormDataResult] = useState(null);

  useEffect(() => {
    setFormDataResult(calculatorDataResult);
  }, [calculatorDataResult]);

  // Limpar o estado local quando o systemType mudar
  useEffect(() => {
    setFormDataResult(null);
  }, [systemType]);

  // Objeto de tradução para os textos em diferentes idiomas
  const languageTexts = {
    "pt-br": {
      title: "Informações Gerais",
      dimensionPretended: "Dimensão Pretendida:",
      dimensionEffective: "Dimensão Efetiva:",
      totalArea: "Área Total:",
      plantCapacity: "Capacidade de Plantas:",
      totalModulesInteiros: "Total Módulos Inteiros:",
      totalModulesNicho: "Total Módulos Nicho:",
      totalModulesDuplos: "Total Módulos Duplos:",
      totalModulesCantoneira: "Total Módulos Cantoneira:",
    },
    en: {
      title: "General Information",
      dimensionPretended: "Pretended Dimension:",
      dimensionEffective: "Effective Dimension:",
      totalArea: "Total Area:",
      plantCapacity: "Plant Capacity:",
      totalModulesInteiros: "Total Whole Modules:",
      totalModulesNicho: "Total Niche Modules:",
      totalModulesDuplos: "Total Double Modules:",
      totalModulesCantoneira: "Total Corner Modules:",
    },
    es: {
      title: "Información General",
      dimensionPretended: "Dimensión Pretendida:",
      dimensionEffective: "Dimensión Efectiva:",
      totalArea: "Área Total:",
      plantCapacity: "Capacidad de Plantas:",
      totalModulesInteiros: "Módulos Enteros Totales:",
      totalModulesNicho: "Módulos de Nicho Totales:",
      totalModulesDuplos: "Módulos Dobles Totales:",
      totalModulesCantoneira: "Módulos de Esquina Totales:",
    },
  };

  // Obtém os textos correspondentes à linguagem selecionada
  const texts = languageTexts[language] || languageTexts["en"]; // Se a linguagem não for encontrada, usa o inglês como padrão

  const {
    alturaJardimVertical,
    alturaParede,
    larguraJardimVertical,
    larguraParede,
    areaJardimVertical,
    totalPlantas,
    totalModulosInteiros,
    totalModulosNicho,
    totalModulosDuplos,
    totalModulosCantoneira,
  } = formDataResult ? formDataResult : {};

  return (
    <div className="general-information ">
      <h2>{texts.title}</h2>
      <div className="information-grid">
        <div>
          <div className="information-item">
            <p>{texts.dimensionPretended}</p>
            {alturaParede && (
              <span id="medidasParede">
                {parseFloat(alturaParede).toFixed(2)}m (A) x{" "}
                {parseFloat(larguraParede).toFixed(2)}m (L)
              </span>
            )}
          </div>
          <div className="information-item">
            <p>{texts.dimensionEffective}</p>
            {alturaJardimVertical && (
              <span id="medidasJardimVertical">
                {alturaJardimVertical.toFixed(2)}m (A) x{" "}
                {larguraJardimVertical.toFixed(2)}m (L)
              </span>
            )}
          </div>
          <div className="information-item">
            <p>{texts.totalArea}</p>
            {areaJardimVertical && (
              <span id="areaTotal">{areaJardimVertical.toFixed(2)}m²</span>
            )}
          </div>
          <div className="information-item">
            <p>{texts.plantCapacity}</p>

            {totalPlantas && (
              <span id="capacidadePlantas">{totalPlantas} plantas</span>
            )}
          </div>
        </div>
        <div>
          <div className="information-item">
            <p>{texts.totalModulesInteiros}</p>

            <span id="totalModulosInteiros">{totalModulosInteiros}</span>
          </div>
          <div className="information-item">
            <p>{texts.totalModulesNicho}</p>

            <span id="totalModulosNicho">{totalModulosNicho}</span>
          </div>
          <div className="information-item">
            <p>{texts.totalModulesDuplos}</p>

            <span id="totalModulosDuplo">{totalModulosDuplos}</span>
          </div>

          {systemType === "wallgreen" && (
            <div className="information-item">
              <p>{texts.totalModulesCantoneira}</p>
              <span id="totalModulosCantoneira">{totalModulosCantoneira}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
